var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 2.20544H4.01C2.91 2.20544 2.009 3.13623 2.009 4.27386L2 16.6834C2 17.8262 2.895 18.7528 4 18.7528H5.499C5.775 18.7528 5.999 18.9845 5.999 19.2699V21.4273C5.999 22.3488 7.076 22.81 7.706 22.1585L10.706 19.0558C10.894 18.8614 11.148 18.7528 11.413 18.7528H19.999C21.099 18.7528 21.999 17.822 21.999 16.6844V4.27386C21.999 3.13623 21.099 2.20544 19.999 2.20544ZM17 12.8557C17 13.1608 16.667 13.3398 16.426 13.1639L14 11.4016V12.5475C14 13.1184 13.552 13.5818 13 13.5818H8C7.448 13.5818 7 13.1184 7 12.5475V8.4107C7 7.83982 7.448 7.37649 8 7.37649H13C13.552 7.37649 14 7.83982 14 8.4107V9.55661L16.426 7.79328C16.667 7.6185 17 7.79742 17 8.10251V12.8557Z",
    fill: "#0044C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallFigma);
export default __webpack_public_path__ + "static/media/video-call-figma.782cef066210a202f7c242b23a79d985.svg";
export { ForwardRef as ReactComponent };